export const MGV_GUEST_CLOSE = 'mgv-guest-close';
export const MGV_GUEST_CALL = 'mgv-guest-call';

/** True when the message comes from the origin used as the myGuest iframe `src`. */
export function isMyGuestEmbedOrigin(origin: string, myGuestUrl: string | undefined): boolean {
  if (!myGuestUrl) {
    return false;
  }
  try {
    return origin === new URL(myGuestUrl).origin;
  } catch {
    return false;
  }
}

export function isMyGuestCloseMessage(data: unknown): boolean {
  return !!data && typeof data === 'object' && (data as { type?: unknown }).type === MGV_GUEST_CLOSE;
}

/** Returns a `tel:` href from `mgv-guest-call`, or null when the payload is unsafe/malformed. */
export function readMyGuestCallHref(data: unknown): string | null {
  if (!data || typeof data !== 'object') {
    return null;
  }
  const message = data as { type?: unknown; href?: unknown };
  if (message.type !== MGV_GUEST_CALL || typeof message.href !== 'string') {
    return null;
  }
  if (!message.href.startsWith('tel:')) {
    return null;
  }
  return message.href;
}

export function openMyGuestTelHref(href: string): void {
  window.open(href, '_self');
}
